import { FCC } from "@/types/common";
import { Typography, styled, Box } from "@mui/material";
import { ReactNode } from "react";
import { EMPTY_STR } from "@/constants/string";
import { black, divider, text } from "@/theme/colors";
import { convertNumberToZipCode } from "@/utils/input";

type TPartnerInfoItem = {
  label?: string;
  value?: string | number | null;
  type?: "string" | "zipcode" | "textArea";
  affix?: ReactNode;
  affixEnd?: ReactNode;
  showDivider?: boolean;
};

export const PartnerInfoItem: FCC<TPartnerInfoItem> = ({ label, value, type = "string", affix, affixEnd, showDivider = true }) => {
  const displayValue = () => {
    if (value === null || value === undefined || value === "") return EMPTY_STR.TEXT;
    if (type === "zipcode") return convertNumberToZipCode(String(value));
    return String(value);
  };

  return (
    <ItemWrap showDivider={showDivider}>
      <LabelRow>
        <Typography variant="cap12" color={black[70]}>
          {label}
        </Typography>
        {affix && <AffixWrap>{affix}</AffixWrap>}
      </LabelRow>
      <ValueRow>
        <Typography
          variant="body14Semi"
          color={text.primary}
          sx={{
            flex: 1,
            whiteSpace: type === "textArea" ? "pre-wrap" : "normal",
            wordBreak: "break-word",
            overflowWrap: "break-word",
          }}
        >
          {displayValue()}
        </Typography>
        {affixEnd}
      </ValueRow>
    </ItemWrap>
  );
};

const options = { shouldForwardProp: (propName: string) => !["showDivider"].includes(propName) };

const ItemWrap = styled(Box, options)<{ showDivider: boolean }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 60px;
  ${({ showDivider }) => showDivider && `padding-bottom: 16px; border-bottom: 1px solid ${divider.middle};`}
`;

const ValueRow = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const LabelRow = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  height: 18px;
`;

const AffixWrap = styled(Box)`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
